import React from "react";
import { Grid, List, ListItemText } from "@mui/material";
import { BodyTypography, HeaderTypography } from "./Typography";

const Nutzungsbedingungen = () => {
  return (
    <Grid container flexDirection="column" alignContent="flex-start">
      <HeaderTypography>Allgemein</HeaderTypography>
      <BodyTypography>
        Im Rahmen unterschiedlicher Kartenprojekte werden durch die TÜV
        Rheinland Consulting GmbH allgemeine sowie sehr spezifische Geodaten
        erstellt und in diesem Portal zur Ansicht oder Bearbeitung
        bereitgestellt. Da sich die meisten Geodaten in den Projekten über die
        Zeit verändern, werden die bereitgestellten Geodaten - zum Beispiel im
        Rahmen einer Pflegeleistung - i.d.R. kontinuierlich aktualisiert und mit
        neuen Sachdaten angereichert, um so etwa bei Planungen zielgerichteter
        reagieren und handeln zu können. D.h., nachträgliche Anpassungen sowie
        stetige Aktualisierungen von georeferenzierten Daten sind entsprechend
        zu erwarten. Zudem werden sämtliche Änderungsmitteilungen auf unseren
        Servern gespeichert, aufbereitet, geprüft und i.d.R. anschließend wieder
        über dieses Informationsportal bereitgestellt.
      </BodyTypography>
      <HeaderTypography>Nutzer:innenkreis</HeaderTypography>
      <BodyTypography></BodyTypography>
      Alle Nutzer:innen, die mindestens einem Kartenprojekt zugeordnet sind,
      sind - im Rahmen ihrer Freigaben - auch die jeweiligen Datennutzer, der
      ihnen freigeschalteten Kartenanwendungen.
      <HeaderTypography>Nutzungsdauer</HeaderTypography>
      <BodyTypography>
        Die Dauer der Nutzungsberechtigung der einzelnen Nutzer:innen ist für
        jede Kartenanwendung separat und individuell geregelt. Ein allgemeines
        Gültigkeitsende besteht nicht.
      </BodyTypography>
      <HeaderTypography>Nutzungsrechte</HeaderTypography>
      <BodyTypography>
        Alle im Portal bereitgestellten Geodaten werden dem Nutzerkreis zur
        Verfügung gestellt. Dabei dürfen die Geodaten ausschließlich von den
        registrierten Nutzer:innen verwendet und nicht an Dritte weitergegeben
        werden. Datenauszüge, Reports oder Karten mit Inhalten von TÜV Rheinland
        Consulting GmbH müssen immer mit einem Copyright gekennzeichnet sein:
        (©2022 TÜV Rheinland Consulting GmbH).
      </BodyTypography>
      <HeaderTypography>Nutzungskosten</HeaderTypography>
      <BodyTypography>
        Die Nutzung des Informationsportals ist, wenn nicht anders geregelt,
        mitunter kostenfrei. Zur Kontrolle des Zugriffs und der Einhaltung
        müssen sich die Nutzer aber dennoch registrieren lassen. Registrierungs-
        und Lizenzgebühren fallen nicht an.
      </BodyTypography>
      <HeaderTypography>Rechtliche Hinweise</HeaderTypography>
      <BodyTypography>
        Die von der TÜV Rheinland Consulting GmbH zur Verfügung gestellten
        Geodaten sind urheberrechtlich geschützt. Insofern setzt die Nutzung
        dieser Daten auch die Anerkennung der im Weiteren aufgeschlüsselten
        Nutzungsbedingungen voraus: Die Nutzer:innen verpflichten sich, dass sie
        als registrierter Account der bereitgestellten Geodaten …
      </BodyTypography>
      <Grid item sx={{ ml: 4 }}>
        <List sx={{ listStyleType: "disc", width: "80%" }}>
          <ListItemText sx={{ display: "list-item" }}>
            die TÜV Rheinland Consulting GmbH als Inhaber der gesamten Rechte
            anerkennen,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            die Nutzung der bereitgestellten Geodaten je nach Verfügbarkeit nur
            auf den kartenspezifischen genehmigten Zweck beschränkt ist,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            die zur Verfügung gestellten Geodaten vor unberechtigten Zugriffen
            Dritter durch geeignete technische und organisatorische Maßnahmen
            des Nutzers geschützt sind,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            zur Weitergabe von Geodaten an Dritte oder daraus abgeleiteter
            Informationen immer die gesonderte schriftliche Erlaubnis durch die
            TÜV Rheinland Consulting GmbH beantragt werden muss,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            beim Bekanntwerden einer regelwidrigen Nutzung der bereitgestellten
            Geodaten oder einer sonstigen Datenschutzverletzung bei der Nutzung
            des Portals unverzüglich die TÜV Rheinland Consulting GmbH zu
            informieren ist,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            alle erstellten analogen oder digitalen Daten, die in Verwendung der
            hier veröffentlichten Geodaten entstanden sind, müssen den folgenden
            Copyrightvermerk tragen: © Copyright TÜV Rheinland Consulting GmbH
            (Dabei soll in Onlineanwendungen - sofern technisch möglich mit
            www.tuv.com verlinkt werden)
          </ListItemText>
        </List>
      </Grid>
      <BodyTypography>Die Nutzer:innen erkennen an, dass …</BodyTypography>
      <Grid item sx={{ ml: 4 }}>
        <List sx={{ listStyleType: "disc", width: "80%" }}>
          <ListItemText sx={{ display: "list-item" }}>
            sich mit kostenfreier Bereitstellung kein ableitbares Recht ergibt,
            die Daten dauerhaft zu nutzen,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            die Verfügbarkeit der Geodaten während Wartungsarbeiten auf dem
            Portal zeitlich eingeschränkt sein kann,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            ausgewählte Geodaten nur zur kostenfreien Einsichtnahme zur
            Verfügung gestellt werden,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            die Weitergabe ausgewählter Geodaten nicht gestattet ist,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            keine Daten in direkter, wie abgeleiteter Form vervielfältigt,
            veröffentlicht oder gar verkauft werden dürfen,
          </ListItemText>
          <ListItemText sx={{ display: "list-item" }}>
            in begründeten Fällen eine Rücknahme der Nutzungsberechtigung
            erfolgen kann, wenn Verletzungen der hier aufgeführten
            Vereinbarungen über die Nutzung der Adressdaten vermutet oder
            nachgewiesen werden können.
          </ListItemText>
        </List>
      </Grid>
      <BodyTypography>
        Hiermit wird vom Unterzeichner bestätigt, dass die Bestimmungen des
        Nutzungsvertrages im genannten Umfang beachtet und eingehalten werden.
      </BodyTypography>
    </Grid>
  );
};

export default Nutzungsbedingungen;
